import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostApplied } from "./components/basic/BasicPostApplied";
import { BasicDetail, BasicDetailSingle } from "./components/basic/BasicDetail";
import { BasicLanguage } from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import { BasicSkillsTwoRows } from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import { BasicFullNameHeader } from "./components/basic/BasicFullName";
import { BasicFace } from "./components/basic/BasicFace";
import { BasicStand } from "./components/basic/BasicStand";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import { BasicHeader } from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicLocation } from "./components/basic/BasicLocation";
import {
  BasicFlagHorz,
  BasicSingleFlagHorz,
} from "./components/basic/BasicFlag";
import {
  BasicHeightWeightHorz,
  BasicHeightWeightHorzDouble,
} from "./components/basic/BasicHeightWeight";
import { BasicReferenceDateOnlyHeader } from "./components/basic/BasicReference";
import { BasicRemarks } from "./components/basic/BasicRemarks";
import { BasicFooter } from "./components/basic/BasicFooter";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
//bg:9cb7d8 becfe5 bdcee4
//Logofont:00275f
function YebadTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  return (
    <>
      <Box
        id="personalData"
        sx={{
          p: 1,
          borderRadius: cvTemplate.borderRadius,
          boxShadow: cvTemplate.headerShadow,
          borderColor: cvTemplate.borderColor,
          borderWidth: cvTemplate.borderWidth as number,
          borderStyle: cvTemplate.borderStyle,
        }}
      >
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            <Grid container item xs={12}>
              <Stack sx={{ width: "100%" }}>
                {cvTemplate && currentEmployee && (
                  <>
                    <BasicFullNameHeader
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                    />
                    <BasicSingleFlagHorz
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                    />
                  </>
                )}
              </Stack>
              <Stack direction="row" sx={{ width: "100%" }}>
                {cvTemplate && currentEmployee && (
                  <>
                    <BasicDetailSingle
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={false}
                      showSalary={false}
                      showPassportNumber={false}
                      showIssueDate={false}
                      showPlaceOfIssue={false}
                      showExpiryDate={false}
                      showLanguage={false}
                      showNationality={false}
                      showReligion={true}
                      showDateOfBirth={false}
                      showAge={false}
                      showPlaceOfBirth={false}
                      showMaritalStatus={true}
                      showNumberOfChildren={false}
                      showWeightHeight={false}
                      showComplexion={false}
                      showEducation={false}
                      showLivingTown={false}
                      showEmployeeTelephone={false}
                      showContactName={false}
                      showContactTelephone={false}
                    />
                    <BasicDetailSingle
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={false}
                      showSalary={false}
                      showPassportNumber={false}
                      showIssueDate={false}
                      showPlaceOfIssue={false}
                      showExpiryDate={false}
                      showLanguage={false}
                      showNationality={false}
                      showReligion={false}
                      showDateOfBirth={false}
                      showAge={false}
                      showPlaceOfBirth={false}
                      showMaritalStatus={false}
                      showNumberOfChildren={true}
                      showWeightHeight={false}
                      showComplexion={false}
                      showEducation={false}
                      showLivingTown={false}
                      showEmployeeTelephone={false}
                      showContactName={false}
                      showContactTelephone={false}
                      showLabourId={true}
                    />
                  </>
                )}
              </Stack>
              <Grid item xs={12} spacing={1}>
                <BasicHeightWeightHorzDouble
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showComplexion={false}
                  showReligion={true}
                  showProfession={true}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <Stack
              spacing={cvTemplate.spacing}
              alignItems="center"
              sx={{
                width: "100%",
                borderRadius: cvTemplate.borderRadius,
                borderColor: cvTemplate.borderColor,
                borderWidth: cvTemplate.borderWidth,
                borderStyle: cvTemplate.borderStyle,
                p: 1,
              }}
            >
              {cvTemplate && currentEmployee && (
                <>
                  <BasicStand
                    currentEmployee={currentEmployee}
                    template={{ ...cvTemplate, standHeight: "700px" }}
                  />
                </>
              )}
            </Stack>
          </Grid>
          <Grid item md={6} xs={12}>
            {cvTemplate && currentEmployee && (
              <>
                <BasicPostApplied
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showHeader={false}
                  showProfession={false}
                  showSalary={true}
                  showContractPeriod={true}
                />
              </>
            )}
            {cvTemplate && currentEmployee && (
              <BasicPassport
                currentEmployee={currentEmployee}
                template={cvTemplate}
                showHeader={false}
                showPassportNumber={true}
                showIssueDate={true}
                showPlaceOfIssue={true}
                showExpiryDate={true}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicDetail
                currentEmployee={currentEmployee}
                template={cvTemplate}
                showHeader={true}
                showNationality={false}
                showReligion={false}
                showDateOfBirth={true}
                showAge={true}
                showPlaceOfBirth={true}
                showMaritalStatus={false}
                showNumberOfChildren={false}
                showWeightHeight={false}
                showComplexion={false}
                showEducation={false}
                showLivingTown={true}
                showEmployeeTelephone={false}
                showContactName={true}
                showContactTelephone={false}
              />
            )}
            {cvTemplate && currentEmployee && (
              <>
                <BasicLanguage
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showEducation={true}
                />
                <BasicExperience
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  type="basic"
                />
              </>
            )}
          </Grid>

          <Grid item xs={12}>
            {cvTemplate && currentEmployee && (
              <BasicSkillsTwoRows
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {cvTemplate && currentEmployee && (
              <BasicFooter
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
        </Grid>
      </Box>
      <Stack
        id="passportData"
        sx={{
          p: 1,
          pt: 1,
          backgroundColor: backgroundColor,
          minHeight: "2000px",
          borderRadius: cvTemplate.borderRadius,
          boxShadow: cvTemplate.headerShadow,
          borderColor: cvTemplate.borderColor,
          borderWidth: cvTemplate.borderWidth as number,
          borderStyle: cvTemplate.borderStyle,
          justifyContent: "space-between",
        }}
      >
        <Stack>
          {cvTemplate.addPassportHeader && (
            <Box>
              {cvTemplate && currentEmployee && (
                <BasicHeader
                  selectedCompany={selectedCompany}
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Box>
          )}

          {cvTemplate && currentEmployee && (
            <Box sx={{ mt: 5 }}>
              <BasicPassportScan
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            </Box>
          )}
        </Stack>

        {cvTemplate && currentEmployee && (
          <Box>
            <BasicFooter
              selectedCompany={selectedCompany}
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}

export default YebadTemplate;
